import { render, staticRenderFns } from "./FormResetPasswordCode.vue?vue&type=template&id=0d8780ec&scoped=true"
import script from "./FormResetPasswordCode.vue?vue&type=script&lang=js"
export * from "./FormResetPasswordCode.vue?vue&type=script&lang=js"
import style0 from "./FormResetPasswordCode.vue?vue&type=style&index=0&id=0d8780ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8780ec",
  null
  
)

export default component.exports